import { Divider, Dropdown } from "antd";
import { UIBalanceWallet } from "../Balance";
import { WalletOutlined } from "@ant-design/icons";

export const DropdownContentWallet = ({ accPayoutActiveBank, loadingBankAccounts, name, t }) => {

    // แยกส่วนเนื้อหาที่จะแสดงใน Dropdown ออกมา
    const content = (
        <div
            className="v-sheet v-theme--CYAN_THEME elevation-10 rounded-md"
            style={{
                width: 250,
                backgroundColor: '#fff', // เพิ่มพื้นหลังเพื่อให้เห็นชัดเจน
                borderRadius: '8px',
                boxShadow: '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)'
            }}
        >
            <div className="pa-4" style={{ padding: '16px' }}>
                <Divider
                    orientation="left"
                    style={{ marginTop: 0 }}
                >
                    <WalletOutlined /> <b style={{ marginLeft: 8 }}>{t("Wallet")}</b>
                </Divider>

                <div className="d-flex justify-space-between w-100" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                    <div>{t("Merchant")}</div>
                    <div className="text-right font-weight-bold" style={{ fontWeight: 'bold' }}>
                        {name}
                    </div>
                </div>

                <UIBalanceWallet
                    accPayoutActiveBank={accPayoutActiveBank}
                    loadingBankAccounts={loadingBankAccounts}
                    t={t}
                />
            </div>


        </div>
    );

    return (
        <Dropdown
            trigger={['click']}
            arrow
            className="hover"
            
            dropdownRender={() => content}
        >
            <WalletOutlined className="fs-16"  />
        </Dropdown>
    );
};